module.exports = {
    DELETE_THRESHOLD: "Are you sure you want to delete this Threshold Leave setting?"
}